import jwtDecode from 'jwt-decode';
//获取token
export function getUserId(Token) {
  let settoken = '';
  if (!Token) {
    settoken = localStorage.getItem('infoToken');
  } else {
    settoken = Token;
  }

  try {
    const decoded = jwtDecode(settoken);
    return decoded.userId || null;
  } catch (e) {
    return null;
  }
}

// 提取所有 id（包含 children 里的）
// const data = [
//   { id: 14, date: '2026-05-14 11:27:42', name: '文章234234' },
//   {
//     id: 13,
//     date: '2026-05-14 11:27:42',
//     name: '文章234234',
//     children: [{ id: 21, date: '2026-05-14 11:27:42', name: '文章234234' }],
//   },
// ];
export function getAllIds(data) {
  let ids = [];
  function loop(arr) {
    arr.forEach((item) => {
      ids.push(item.id); // 提取自身 id
      if (item.children) {
        // 如果有 children
        loop(item.children); // 递归提取子级 id
      }
    });
  }
  loop(data);
  return ids;
}
